export enum CheckoutPageView {
    LOADING,
    DELIVERY_ADDRESS,
    PAYMENT,
    CONFIRMATION
}